import React from "react";
import { useFormikContext } from "formik";
import { bool, func, string } from "prop-types";

import DrawerFormButtons from "src/shared/contact-boxes/components/DrawerFormButtons";

import { useDrawerContext } from "../../utilities/drawerHelpers";

const DrawerButtons = ({
  cancelText,
  hasCancelOnMobile,
  onCancel,
  submitText
}) => {
  const hasDrawerForm = useDrawerContext();
  const { isSubmitting } = useFormikContext();

  if (!hasDrawerForm) {
    return null;
  }

  return (
    <DrawerFormButtons
      cancelText={cancelText}
      hasCancelOnMobile={hasCancelOnMobile}
      isSubmitting={isSubmitting}
      onCancel={onCancel}
      onClickSubmit={() => null}
      submitText={submitText}
    />
  );
};

DrawerButtons.propTypes = {
  cancelText: string,
  hasCancelOnMobile: bool,
  onCancel: func.isRequired,
  submitText: string
};

DrawerButtons.defaultProps = {
  cancelText: "Cancel",
  hasCancelOnMobile: false,
  submitText: "Submit"
};

export default DrawerButtons;
